module.exports = __webpack_public_path__ + "static/media/5.41cb1e24.jpeg";